import { render, staticRenderFns } from "./DetailsProject.vue?vue&type=template&id=21f86558&scoped=true&lang=html&"
import script from "./DetailsProject.vue?vue&type=script&lang=js&"
export * from "./DetailsProject.vue?vue&type=script&lang=js&"
import style0 from "./DetailsProject.vue?vue&type=style&index=0&id=21f86558&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f86558",
  null
  
)

export default component.exports